var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9974 38.1296C11.2537 34.1593 10.2758 32.3428 7.92969 29.5422C11.1867 29.1958 13.0301 29.0799 16.0651 27.7344L18.0236 36.9244C15.8553 36.8858 14.5194 37.1947 11.9974 38.1296Z",
    fill: "#FFA254"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4598 46.8669C18.508 46.7721 19.6782 46.2643 21.486 40.9913C19.6782 40.3887 21.3097 38.599 19.2262 38.7315C16.9663 38.4302 14.4052 38.7315 10.4881 40.5393C9.88552 35.2664 8.328 31.0268 4.4619 29.8428C3.22721 29.8731 2.87853 30.4556 2.80469 32.4039C3.106 38.7315 8.549 46.6301 15.4598 46.8669Z",
    fill: "#A16B3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3936 18.748C43.082 21.5204 43.4746 24.7206 43.6366 28.7884C43.9716 41.8256 37.8785 45.0492 20.7369 46.7164C28.119 37.8277 20.7369 19.5984 11.5469 10.107C20.8012 7.02296 26.0982 6.00678 35.8025 5.88867C38.0889 9.01379 39.7899 11.6594 41.017 14.5794C43.1487 11.4535 44.5827 9.7055 46.9529 7.54602C43.4809 12.7798 42.4201 15.7429 42.3936 18.748Z",
    fill: "url(#paint0_linear_210_105878)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6769 4.38216L27.3625 0.314453C16.1074 1.76446 10.1664 3.70086 0.09375 8.75118C12.5982 16.8866 21.7762 35.5679 14.2554 44.306L19.679 45.0593C26.6092 34.664 16.6659 16.7359 8.37982 9.65512C16.0473 6.60563 20.8321 5.35901 30.6769 4.38216Z",
    fill: "url(#paint1_linear_210_105878)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4832 31.1991C29.9557 27.5943 28.376 26.0268 25.4023 23.6663C27.0836 23.5445 28.5227 23.9987 31.5792 25.3236C33.8391 20.6532 40.2907 10.8848 46.7955 7.39551C39.9791 15.2149 36.8609 20.4469 32.4832 31.1991Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.6963,
    cy: 13.7229,
    rx: 1.65722,
    ry: 1.80787,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5691,
    cy: 12.3672,
    rx: 1.50656,
    ry: 1.65722,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.6857,
    cy: 11.1616,
    rx: 1.20525,
    ry: 1.3559,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_210_105878",
    x1: 33.0918,
    y1: 33.308,
    x2: 22.2447,
    y2: 46.8677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A26B3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_210_105878",
    x1: 22.8428,
    y1: 31.5002,
    x2: 15.3853,
    y2: 45.0593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#052973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2A2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.204d17b55808308a051f78d87dab44a8.svg";
export { ForwardRef as ReactComponent };